export const getRandNumericID = () => {
  return Number(Math.random().toString().substring(2));
};
